import React from 'react';
import ReactDOM from 'react-dom';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClose, faCheckCircle, faHeart, faComments } from '@fortawesome/free-solid-svg-icons';
import '../../../core/styles/boat/BoatLeadSuccessModal.css';

const ShareExperienceSuccessModal = ({ onClose }) => {
  const coreApp = document.getElementById('core-app');

  if (!coreApp) {
    return null;
  }
  
  return ReactDOM.createPortal(
    <div className="core__modal" onClick={onClose}>
        <div className="core__modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="core__modal-header">
                <h2>Thank You!</h2>
                <button className="core__modal-close" onClick={onClose}>
                    <FontAwesomeIcon icon={faClose} />
                </button>
            </div>
            <div className="core__modal-body">
                <div className="boat-success__icon-wrapper">
                    <FontAwesomeIcon icon={faCheckCircle} className="boat-success__icon" />
                </div>
                <h3 className="boat-success__title">Your experience has been shared!</h3>
                <p className="boat-success__text">
                    Thank you for sharing your boating adventure with our community. We'll review your story and may feature it on our blog to inspire other boaters.
                </p>
                
                <div className="boat-success__promo">
                    <h4>Keep exploring our community!</h4>
                    <div className="boat-success__promo-options">
                        <Link to="/blog" className="promo-option blog" onClick={onClose}>
                            <FontAwesomeIcon icon={faComments} className="promo-icon" />
                            <span className="promo-label">Read More Stories</span>
                        </Link>
                        <Link to="/" className="promo-option home" onClick={onClose}>
                            <FontAwesomeIcon icon={faHeart} className="promo-icon" />
                            <span className="promo-label">Plan Your Trip</span>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    </div>,
    coreApp
  );
};

export default ShareExperienceSuccessModal;







